import { render, staticRenderFns } from "./ListaTiendasMobile.vue?vue&type=template&id=4978df12&scoped=true&"
import script from "./ListaTiendasMobile.vue?vue&type=script&lang=js&"
export * from "./ListaTiendasMobile.vue?vue&type=script&lang=js&"
import style0 from "./ListaTiendasMobile.vue?vue&type=style&index=0&id=4978df12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978df12",
  null
  
)

export default component.exports